
export const TRIGGER_SOLUTION_TYPE_ERROR_MESSAGE = "Error occurred while fetching the triggers and solution types.";
export const getTriggerAndSolutionTypeAccessErrorMessage = (
  triggerAndSolutionType: string[],
  existingTrigger: string,
  existingSolutionType: string
) => {
  if (!triggerAndSolutionType.includes(existingTrigger) && !triggerAndSolutionType.includes(existingSolutionType)) {
    return `User does not have access to existing trigger "${existingTrigger}" and solution type "${existingSolutionType}"`;
  } else if (!triggerAndSolutionType.includes(existingTrigger)) {
    return `User does not have access to existing trigger "${existingTrigger}"`;
  } else if (!triggerAndSolutionType.includes(existingSolutionType)) {
    return `User does not have access to existing solution type "${existingSolutionType}"`;
  } else {
    return null;
  }
}
export const PROMOTE_TO_BETA_ERROR_MESSAGE = "Error occurred while promoting the event to Beta: ";
export const PROMOTE_TO_PROD_ERROR_MESSAGE = "Error occurred while promoting the event to Prod: ";
export const SAVE_ERROR_MESSAGE = "Error occurred while saving the event: ";

